module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_user-99e49ce68ab2b87aa222ddda87440402.svg";